import { useState } from "react";

const faqs = [
  {
    q: "如何在歪歪官方网站下载并安装客户端？",
    a: "进入歪歪官方网站首页，点击「立即下载」选择对应系统（Windows/macOS/Android/iOS），下载完成后按引导安装即可；若暂时不方便安装，也可直接使用网页版在线进入频道。",
  },
  {
    q: "如何开通歪歪会员？",
    a: "登录账号后，进入会员中心选择会员套餐，支持月卡、季卡、年卡多种时长选项，按页面引导完成支付即可开通，会员权益即时生效。",
  },
  {
    q: "充值后多久可以到账？",
    a: "通过官方渠道充值通常实时到账，若因网络或支付平台原因出现延迟，一般会在数分钟内到账。若超过约定时间仍未到账，可联系在线客服协助核实处理。",
  },
  {
    q: "如何联系歪歪在线客服？",
    a: "您可在官方网站「客服帮助」板块点击「在线客服」按钮，或通过客服邮箱 service@yy-support.example.com 与我们联系，工作时间内即时响应。",
  },
  {
    q: "忘记账号或密码怎么办？",
    a: "在登录页面点击「忘记密码」，通过绑定的手机号或邮箱验证后即可重置。若因更换手机等原因无法找回，请联系客服协助核实身份后处理。",
  },
  {
    q: "开黑时语音卡顿或延迟怎么办？",
    a: "建议优先切换网络环境、关闭占用带宽的后台程序，并在客户端内适当调整语音清晰度。若问题依旧，可联系在线客服获取进一步排查帮助。",
  },
];

const channels = [
  { icon: "ri-customer-service-2-line", title: "在线客服", desc: "工作时间内即时回复，真人客服一对一协助。", cta: "开始咨询" },
  { icon: "ri-mail-send-line", title: "客服邮箱", desc: "service@yy-support.example.com", cta: "发送邮件" },
  { icon: "ri-question-answer-line", title: "帮助中心", desc: "常见问题、操作指南与使用手册一站式查询。", cta: "前往查阅" },
];

export default function Support() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="help" className="relative bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-accent-400">
              <i className="ri-service-line" aria-hidden="true"></i>
              客服帮助
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">有问题？我们随时在线</h2>
            <p className="mt-4 text-foreground-300">
              下载、会员、充值或使用过程中遇到任何问题，都可以通过多种渠道快速获得帮助。我们会第一时间响应你的每一次求助。
            </p>

            <div className="mt-7 space-y-4">
              {channels.map((c) => (
                <article key={c.title} className="rounded-xl border border-background-200/70 bg-background-50 p-5 flex items-center gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-500/15 text-primary-400">
                    <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-base text-foreground-50">{c.title}</h3>
                    <p className="mt-0.5 truncate text-sm text-foreground-400">{c.desc}</p>
                  </div>
                  <span className="hidden sm:block shrink-0 text-sm text-primary-300 whitespace-nowrap">{c.cta}</span>
                </article>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-xl text-foreground-50">常见问题</h3>
            <div className="mt-4 space-y-3">
              {faqs.map((faq, i) => {
                const open = openIndex === i;
                return (
                  <div
                    key={faq.q}
                    className={`rounded-xl border transition-colors ${
                      open ? "border-primary-400/50 bg-background-50" : "border-background-200/70 bg-background-50"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      aria-expanded={open}
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-50">{faq.q}</span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${open ? "rotate-45 text-primary-400" : "text-foreground-400"}`}>
                        <i className="ri-add-line text-lg" aria-hidden="true"></i>
                      </span>
                    </button>
                    {open && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-300">{faq.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}